import { IResetPassRequest } from "../interfaces/authCommon";

export const mapResetPassRequest = (key: any, data: any): IResetPassRequest => {
  return {
    key,
    password: data.password,
  };
};
